import { PersonFormDto, type PersonFormInterface } from '@zaoblako/shared/modules/client/dtos/person/person-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { BankDetailsUpdateDto, type BankDetailsUpdateInterface } from '@zaoblako/shared/modules/client/dtos/bank.details/bank.details.update.dto';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { KktFindInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-find.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { TenantFindInterface } from '@zaoblako/shared/modules/saas/dtos/tenant-find.dto';
import type { ActivityFindInterface } from '@zaoblako/shared/modules/finance/dtos/activity/activity-find.dto';

import * as yup from 'yup';

/** Counterparty create or update requests body */
export interface ContragentFormInterface extends PersonFormInterface {
  /** Unique identifier */
  id?: number;
  /** Counterparty bank details */
  bankDetails?: BankDetailsUpdateInterface[];
  /** Client this counterparty belongs to */
  client?: ClientFindInterface;
  /** Tenant which represented by this counterparty in billing system */
  representedTenant?: TenantFindInterface;
  /** Counterparty activity */
  activity?: ActivityFindInterface;
  /** Counterparty kkts */
  kkts?: KktFindInterface[];
}

/** Counterparty create or update requests body - DTO schema */
export const ContragentFormDto = SerdeDtoClass.from<PersonFormInterface, ContragentFormInterface>(
  PersonFormDto,
  ClientDtoKeysEnum.CONTRAGENT_FORM_DTO,
  {
    bankDetails: {
      optional: true,
      label: 'Банковские реквизиты',
      nested: BankDetailsUpdateDto,
      serializer: (_, nested) => yup.array(nested),
    },
    client: {
      optional: true,
      label: 'Клиент',
      serializer: entityLikeSchema,
    },
    representedTenant: {
      optional: true,
      label: 'Представляет тенант',
      serializer: entityLikeSchema,
    },
    activity: {
      optional: true,
      label: 'Вид деятельности',
      serializer: entityLikeSchema,
    },
    kkts: {
      optional: true,
      label: 'Кассы',
      serializer: yup.array(entityLikeSchema),
    },
  },
);

